/**
 * Must list every member of the `AppConfigFeatureFlagKey` union.
 * TypeScript will raise a compile error if a new key is added to the union
 * without being added here, because `KNOWN_FLAG_KEY_MAP` must be exhaustive.
 */
const KNOWN_FLAG_KEY_MAP: Record<AppConfigFeatureFlagKey, true> = {
  stripe: true,
  mobileDashboardRedesign: true,
  showIntegrations: true,
  wealthbox: true,
  redtail: true,
  salesforce: true,
  ltcFinancialPlanning: true,
  hidePersonalizePlan: true,
  overviewSlide: true,
  useFormProvider: true,
  usageMetrics: true,
  complianceBCCEmails: true,
  newReportPdfDesign: true,
  inviteClientDialog: true,
  nycLifeDemo: true,
  customPremiumInput: true,
  animatedSlides: true,
  stripeSubscriptionCancellation: true,
  advisorClientLogin: true,
  oneAmericaExpandedStates: true,
  hideInviteEmailAndFillIntakeForm: true,
  policiesComparisonV2: true,
  pdfRoiDisplaySettings: true,
  ltcCostRoundingOptions: true,
  coupleQuickPlan: true,
  sendPolicyViaGenworthAPI: true,
  sendPolicyViaGenworthAPIAndSftp: true,
  hideSubscriptionManagement: true,
  triggerUncancelDripCampaign: true,
  selfFundingGrowthPreview: true,
  existingLtcPolicyTypeOnCard: true,
  checkoutLeaveAndBookDemo: true,
  coverageGap: true,
  fullCare247Override: true,
  partnerFundingSplit: true,
  guidedPlanningSetPremium: true,
  guidedPlanningPremiumBudgetStep: true,
  anonymousPUI: true,
  onboardingPdfReportOptions: true,
  licensesManagement: true,
  wagClients: true,
  selfFundingAdvancedOptions: true,
  advisorIntakeGuideEmail: true,
  reactPdfReport: true,
  asyncIllustrations: true,
  structuredUnderwriting: true,
  persistentFilters: true,
  retirementIncomeExpanded: true,
  shareSpecificClients: true,
  multipleJointPolicies: true,
  rateActionLetterUpload: true,
  claimProjectionEngine: true,
  dynamicClientConsentCopy: true,
  claimProjectionEngineDefault: true,
  policyModelingMaintenanceBanner: true,
  distributionPartnersEnabled: true,
  distributionPartnersForEdj: true,
};

export const KNOWN_FLAG_KEYS = (
  Object.keys(KNOWN_FLAG_KEY_MAP) as AppConfigFeatureFlagKey[]
).sort() as readonly AppConfigFeatureFlagKey[];

export function isKnownFlagKey(key: string): key is AppConfigFeatureFlagKey {
  return Object.prototype.hasOwnProperty.call(KNOWN_FLAG_KEY_MAP, key);
}
